var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.53 8.49-2.466-3.648a.585.585 0 0 0-.532-.258.583.583 0 0 0-.49.33l-.483.994-.355-.174a7.256 7.256 0 0 0-5.57-.301c-1.787.634-3.203 1.91-3.985 3.592-1.606 3.448-.128 7.605 3.292 9.27a7.016 7.016 0 0 0 8.701-2.122 1.06 1.06 0 0 0 .18-.887 1.062 1.062 0 0 0-.569-.706l-.058-.03a1.077 1.077 0 0 0-1.329.335 4.835 4.835 0 0 1-5.963 1.436c-2.352-1.143-3.367-4.002-2.263-6.373a4.722 4.722 0 0 1 2.735-2.46 5.01 5.01 0 0 1 3.85.209l.375.183-.483.993a.585.585 0 0 0 .042.59.587.587 0 0 0 .533.261l4.392-.31a.583.583 0 0 0 .49-.332.585.585 0 0 0-.042-.59l-.002-.003z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatButton);
export default __webpack_public_path__ + "static/media/repeat-button.65046026cc52c6840132d30534c0d17f.svg";
export { ForwardRef as ReactComponent };